module.exports = __webpack_public_path__ + "assets/img/block-left-hover-19513598.png";